import React from 'react'
import './position.scss';

const Position = () => {
    return (
        <section className='position_main' id='whynow'>
            <video className='main-banner-video'
                muted="muted" playsinline="playsinline"
                autoPlay
                loop
                width="100%"
                id="myVideo">
                <source src="\assets\newvideo.mp4" type="video/mp4" />
            </video>
            <div className='custom-container'>
                <div className='innner_section'>
                    <h2>Position Yourself for the Next Wave of Crypto Growth</h2>
                    <p>Invest with confidence in the future of crypto.</p>
                    {/* <div className='butttons_side'>
                        <button className='get'>Get Started</button>
                        <button className='downlod'>Download Pitch Deck</button>
                    </div> */}

                </div>

            </div>
        </section>
    )
}

export default Position
